import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import {
  ApplicationProvider,
  useApplicationContext,
} from "./pages/edit/ApplicationContext";
import { RouterTabs } from "@poseidon/ui/components/RouterTabs";
import { BoatOptionsProvider } from "../Boats/BoatOptionsContext";
import { SailorVulnerabilityFlags } from "../Sailors/components/SailorVulnerabilityFlags";

const tabs = [
  {
    to: "",
    label: "Application",
  },
  {
    to: `/creditUnderwriting`,
    label: "Credit Underwriting",
  },
];

function ApplicationSailorsFlags() {
  const application = useApplicationContext();
  return (
    <SailorVulnerabilityFlags
      sailors={application.applicants?.map((applicant) => applicant.sailor)}
    />
  );
}

const ApplicationsOutlet = () => {
  useCrumb("/applications/", {
    to: `/applications`,
    text: "Applications",
  });
  const { applicationId } = useParams();
  if (applicationId) {
    const baseHref = `/applications/${applicationId}`;
    return (
      <ApplicationProvider applicationId={applicationId}>
        <BoatOptionsProvider>
          <ApplicationSailorsFlags />
          <RouterTabs tabs={tabs} baseHref={baseHref} />
        </BoatOptionsProvider>
      </ApplicationProvider>
    );
  } else {
    return <Outlet />;
  }
};

export default ApplicationsOutlet;
